var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_14347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0991 2.99055C16.6091 2.50055 15.8191 2.50055 15.3291 2.99055L7.01906 11.3005C6.62906 11.6905 6.62906 12.3205 7.01906 12.7105L15.3291 21.0205C15.8191 21.5105 16.6091 21.5105 17.0991 21.0205C17.5891 20.5305 17.5891 19.7405 17.0991 19.2505L9.85906 12.0005L17.1091 4.75055C17.5891 4.27055 17.5891 3.47055 17.0991 2.99055Z",
    fill: "#4C60E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_14347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackBlue);
export default __webpack_public_path__ + "static/media/ArrowBackBlue.447c2e4a461c870c30a037adece1a576.svg";
export { ForwardRef as ReactComponent };